<template>
  <div class="err-msg" v-html="getErr" />
</template>

<script>
const errors = {
  /* REGISTER MODAL */
  emailTaken: `An account with this email already exists.`,
  invalidEmail: `Please enter a valid email address.`,
  passwordErr: `Password must be 8 characters or more and contain at least 1 digit.`,

  /* LOGIN */
  incorrectLogin: `Incorrect email or password.`,
  successfulLogin: `You have signed in successfully.`,

  /* REGISTER PINCODE */
  pinCodeError: `The verification code is incorrect.`,

  /* FORM FIELDS */
  requiredFields: `Please correct the marked fields.`,

  /* COMMENTS */
  /* Appears when there is no comments added */
  noComments: `No comments have been registered.`,

  /* FILE UPLOADS */
  /* Appears when document size is exceeded  */
  fileToBig: `The file size exceeds the limit of 20 MB.`,

  /* Appears when there is no documents in db to show */
  noDocuments: `No documents have been uploaded.`,

  /* Appears when user try to delete comment */
  delComment: `Please confirm that you want to delete this comment.`,

  /* Appears when there is no activities added */
  noActivities: `No records found`,

  /* Appears when there is no emails added */
  noEmails: `No email correspondence.`,

  /* Appears when there is no candidates in DB */
  // noCandidates: `No Candidates have been added.`,

  /* Appears when there is no candidates in DB */
  noCandidates: `No records found`,

  /* Appears when there is no recent placements in DB */
  noRecentPlacements: `No records found`,

  /* Appears when there is no jobs in DB */
  // noJobs: `No Jobs have been added.`,
  noJobs: `No records found`,

  /* Appears when there is employers in DB */
  noEmployers: `No Employers have been added.`,
  noEmployerLogs: `No records found`,
  /* Appears when user add competences filter and type invalid competence name */
  noCompetence: `Sorry, no matching competence`,

  /* Appears when user add languages filter and type invalid language name */
  noLanguage: `Sorry, no matching language`,

  /* Appears in Add Candidate when user type invalid country name */
  noCountry: `Sorry, no matching country`,

  /* Appears in Add to pipeline when user type invalid employer name */
  employerNotFound: `Sorry, no matching employer`,

  /* Appears in Add to pipeline when user type invalid job name */
  jobNotFound: `Sorry, no matching job`,

  /* Appears when there is no applications in DB */
  noApplications: `No records found`,

  /* Appears when there is no jobs for reviw in DB */
  noReviewJobs: `No jobs have been found.`,
  noReviewTests: `No tests have been found.`,

  /* Appears when there is no pipeline in DB */
  noPipelines: `No records found`,
};

export default {
  props: { name: { type: String }, phrase: { type: String } },
  computed: {
    getErr() {
      return `${errors[this.name]} ${this.phrase ? this.phrase : ''}`;
    },
  },
};
</script>
